import { ChallengeService } from '@duck/api-definitions'
import { TranslationKey, useTar } from '@/modules'
import { cn } from '@duck/ui'

const WEAPON_LABEL_KEY: Record<ChallengeService.TaskWeaponsOfChoiceEnum, TranslationKey> = {
  [ChallengeService.TaskWeaponsOfChoiceEnum.Sql]: 'common.sql',
  [ChallengeService.TaskWeaponsOfChoiceEnum.Python]: 'common.python',
}

interface AllowedWeaponsPillsProps {
  allowedWeapons: ChallengeService.TaskWeaponsOfChoiceEnum[] | undefined
  chosenWeapon?: ChallengeService.TaskWeaponsOfChoiceEnum
  className?: string
}

export const AllowedWeaponsPills = ({
  allowedWeapons,
  chosenWeapon,
  className,
}: AllowedWeaponsPillsProps) => {
  const { t } = useTar()
  const weapons = allowedWeapons && allowedWeapons.length > 0
    ? allowedWeapons
    : [ChallengeService.TaskWeaponsOfChoiceEnum.Sql]
  const hasChoice = weapons.length > 1 && chosenWeapon != null

  return (
    <div className={cn('flex items-center gap-1.5', className)}>
      {weapons.map((w) => {
        const isChosen = hasChoice && w === chosenWeapon
        const isDimmed = hasChoice && !isChosen
        return (
          <span
            key={w}
            className={cn(
              'px-2 py-0.5 text-[10px] font-medium rounded-full border uppercase tracking-wide',
              isChosen && 'bg-accent/20 text-accent border-accent/40',
              isDimmed && 'bg-muted/10 text-muted-foreground border-muted/20 opacity-60',
              !hasChoice && 'bg-muted/10 text-muted-foreground border-muted/20'
            )}
          >
            {t(WEAPON_LABEL_KEY[w])}
          </span>
        )
      })}
    </div>
  )
}
